import MainRoutes from '@/router/MainRoutes';
import _ from 'lodash';
import { store, key } from '@/storeVuex';
import HomeIcon from '@/layouts/full/vertical-sidebar/Icons/HomeIcon.vue';
import EstimatesIcon from '@/layouts/full/vertical-sidebar/Icons/EstimatesIcon.vue';
import ProjectsIcon from '@/layouts/full/vertical-sidebar/Icons/ProjectsIcon.vue';
import SchedulesIcon from '@/layouts/full/vertical-sidebar/Icons/SchedulesIcon.vue';
import ProjectNotesIcon from '@/layouts/full/vertical-sidebar/Icons/ProjectNotesIcon.vue';
import StorageIcon from '@/layouts/full/vertical-sidebar/Icons/StorageIcon.vue';
import InternalUsersIcon from '@/layouts/full/vertical-sidebar/Icons/InternalUsersIcon.vue';
import CustomersIcon from '@/layouts/full/vertical-sidebar/Icons/CustomersIcon.vue';
import ManageRolesIcon from '@/layouts/full/vertical-sidebar/Icons/ManageRolesIcon.vue';
import CalculatorIcon from '@/layouts/full/vertical-sidebar/Icons/CalculatorIcon.vue';
import NCCIcon from '@/layouts/full/vertical-sidebar/Icons/NCCIcon.vue';
import TimeTrackerIcon from '@/layouts/full/vertical-sidebar/Icons/TimeTrackerIcon.vue';
import SupplierIcon from '@/layouts/full/vertical-sidebar/Icons/SupplierIcon.vue';
import EquipmentIcon from '@/layouts/full/vertical-sidebar/Icons/EquipmentIcon.vue';
import BulkImportIcon from '@/layouts/full/vertical-sidebar/Icons/BulkImportIcon.vue';
import ProjectSettingsIcon from '@/layouts/full/vertical-sidebar/Icons/ProjectSettingsIcon.vue';
import {
    DashboardIcon,
    CalendarCheckIcon,
    ListCheckIcon,
    CardboardsIcon,
    ApertureIcon,
    CalendarTimeIcon,
    UserIcon,
    BoxSeamIcon,
    BuildingIcon,
    UserStarIcon,
    BoxIcon,
    RulerIcon,
    FilePlusIcon,
    SparklesIcon,
    FileDescriptionIcon,
    ShieldCheckIcon
} from 'vue-tabler-icons';

export interface menu {
    header?: string;
    ispage?: boolean;
    title?: string;
    icon?: any;
    isusertype?: any;
    to?: string;
    chip?: string;
    chipBgColor?: string;
    chipColor?: string;
    chipVariant?: string;
    chipIcon?: string;
    children?: menu[];
    child?: any;
    disabled?: boolean;
    type?: string;
    subCaption?: string;
    isPage?: boolean;
    proj_manage?: any;
    isrole?: any;
    // Plan-gate key (see stores/planAccess.ts::isAllowed). NavItem renders
    // a lock + Upgrade chip when the user's plan lacks this feature.
    requiresPlanFeature?: string;
    // Runtime feature-flag key (see stores/featureFlags). Hidden per-environment
    // when this key is in the backend's HIDDEN_FEATURES.
    featureKey?: string;
}

function mRoute(val) {
    const index = _.findLastIndex(MainRoutes.children, function (chr) {
        return chr.name == val;
    });
    return MainRoutes.children[index];
}
// function checkrole(val){
//    if(store.state.user.user){
//       let concat = val + '__View';
//          if(store.state.user.user.roles[concat] != undefined){
//            return store.state.user.user.roles[concat];
//          }else{
//            return null;
//          }
//     };
// }

const sidebarItem: menu[] = [
    //   { header: 'Home',ispage:false,child:['dashboard'] },
    {
        title: mRoute('dashboard').meta.title,
        to: mRoute('dashboard').name,
        icon: HomeIcon,
        isPage: mRoute('dashboard').isPage
    },
    // Roadmap is NOT listed here. c735ada4 moved it into the top-right header
    // cluster and deleted the horizontal nav entry, but left this copy behind --
    // so the mobile drawer showed it twice, once as the rocket button and once
    // as a sidebar row. The header button carries no responsive hiding, so
    // mobile keeps it.

    // Mat AI -- Builder (limited) and Pro (unlimited) only. Gated for
    // Freemium/Tradie via PlanGate's `mat_ai` level. Mirrors horizontalItems.ts.
    {
        title: 'Mat AI',
        to: mRoute('mat_ai')?.name,
        icon: SparklesIcon,
        isPage: mRoute('mat_ai')?.isPage,
        requiresPlanFeature: 'mat_ai',
        featureKey: 'mat_ai'
    },
    { header: 'Project Management', ispage: true, proj_manage: 'proj_manage', child: ['jobs', 'notes', 'estimate'] },
    //   {
    //      title: mRoute('jobs_sub').meta.title,
    //      to: mRoute('jobs_sub').name,
    //      icon: CalendarCheckIcon,
    //      isPage: mRoute('jobs_sub').isPage,
    //      proj_manage:'subvendor',
    //   },
    {
        title: mRoute('jobs').meta.title,
        to: mRoute('jobs').name,
        icon: ProjectsIcon,
        isPage: mRoute('jobs').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'projects'
    },
    {
        title: mRoute('estimates').meta.title,
        to: mRoute('estimates').name,
        icon: EstimatesIcon,
        isPage: mRoute('estimates').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'estimates'
    },
    {
        title: mRoute('schedules').meta.title,
        to: mRoute('schedules').name,
        icon: SchedulesIcon,
        isPage: mRoute('schedules').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'scheduling'
    },
    {
        title: mRoute('client_portal').meta.title,
        to: mRoute('client_portal').name,
        icon: FileDescriptionIcon,
        isPage: mRoute('client_portal').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'quotes',
        featureKey: 'quotes'
    },
    {
        title: mRoute('team_tracker').meta.title,
        to: mRoute('team_tracker').name,
        icon: TimeTrackerIcon,
        isPage: mRoute('team_tracker').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'crew_tracker'
    },
    // {
    //     title: mRoute('equipment_tracker').meta.title,
    //     to: mRoute('equipment_tracker').name,
    //     icon: EquipmentIcon,
    //     isPage: mRoute('equipment_tracker').isPage,
    //     proj_manage: 'proj_manage'
    // },
    {
        title: mRoute('notes').meta.title,
        to: mRoute('notes').name,
        icon: ProjectNotesIcon,
        isPage: mRoute('notes').isPage,
        proj_manage: 'proj_manage'
    },
    {
        title: mRoute('file_manager').meta.title,
        to: mRoute('file_manager').name,
        icon: StorageIcon,
        isPage: mRoute('file_manager').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'storage'
    },
    {
        title: mRoute('defects')?.meta?.title || 'Defects',
        to: mRoute('defects')?.name,
        icon: ListCheckIcon,
        isPage: mRoute('defects')?.isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'defects'
    },
    {
        title: mRoute('calculator').meta.title,
        to: mRoute('calculator').name,
        icon: CalculatorIcon,
        isPage: mRoute('calculator').isPage,
        proj_manage: 'proj_manage'
    },
    {
        title: mRoute('ncc_assistant').meta.title,
        to: mRoute('ncc_assistant').name,
        icon: NCCIcon,
        isPage: mRoute('ncc_assistant').isPage,
        proj_manage: 'proj_manage'
    },
    // NCC Visual Details and NCC Reference are deliberately NOT separate rows.
    // permission_catalogue.php treats all three pages as ONE feature -- they are
    // aliases of `ncc_assistant`, so a role granted NCC gets a __View key for
    // each -- and the desktop menu has always shown the single combined entry
    // above. Listing the other two here meant anyone with NCC access saw three
    // NCC rows on a phone and one on a desktop. Both pages stay reachable from
    // inside the Assistant.
    // {
    //     title: mRoute('equipments').meta.title,
    //     to: mRoute('equipments').name,
    //     icon: EquipmentIcon,
    //     isPage: mRoute('equipments').isPage,
    //     proj_manage: 'proj_manage'
    // },
    { header: 'OHS', ispage: true, proj_manage: 'ohs', child: ['ohs'] },
    {
        title: mRoute('ohs').meta.title,
        to: mRoute('ohs').name,
        icon: ShieldCheckIcon,
        isPage: mRoute('ohs').isPage,
        proj_manage: 'ohs'
    },
    {
        header: 'User Management',
        isusertype: 1,
        ispage: true,
        proj_manage: 'user_management',
        child: ['internal_users', 'customers', 'suppliers', 'user_roles', 'equipments', 'bulk_import']
    },
    {
        title: mRoute('internal_users').meta.title,
        to: mRoute('internal_users').name,
        icon: InternalUsersIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('internal_users').isPage
    },
    {
        title: mRoute('equipments').meta.title,
        to: mRoute('equipments').name,
        icon: EquipmentIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('equipments').isPage
    },
    {
        title: mRoute('customers').meta.title,
        to: mRoute('customers').name,
        icon: CustomersIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('customers').isPage
    },
    {
        title: mRoute('suppliers').meta.title,
        to: mRoute('suppliers').name,
        icon: SupplierIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('suppliers').isPage
    },
    {
        title: mRoute('user_roles').meta.title,
        to: mRoute('user_roles').name,
        icon: ManageRolesIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('user_roles').isPage
    },
    {
        title: mRoute('bulk_import').meta.title,
        to: mRoute('bulk_import').name,
        icon: BulkImportIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('bulk_import').isPage
    },
    // Developer Portal is hidden from the nav for the time being. It was only
    // ever listed here and never in horizontalItems.ts, so it showed up on a
    // phone and nowhere on a desktop. The route and the page are untouched --
    // it stays reachable by URL for anyone whose role grants `developer_portal`
    // -- this only removes the inconsistent menu entry until there is a
    // decision about where it belongs and which plans get it.
    // At-Risk Trials is NOT listed here. It is OUR page, not a customer's: it
    // scores BuiltSimple's own trial accounts for churn risk, and it is the one
    // entry in this file with no row in config/permission_catalogue.php. With no
    // catalogue row there is no `at_risk_trials__View` key, so NavItem.checkrole
    // hid it from every role -- except Full Admins, who bypass the check
    // entirely. The result was every customer's own admin seeing an internal
    // ops page in their mobile menu. It belongs in bswebappadmin; the route is
    // gated to internal staff in MainRoutes.ts.
];

export default sidebarItem;
